export default {
	"foresite": {
		"addSize": "t添加站点"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/foresite/foresite.js